import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import Customer from '@/App/Customer/Entity/Customer'
import CompanyCustomer from '@/App/Company/Entity/CompanyCustomer'
import type { CompanyCustomerAggregateData } from '@/Shared/AutoGenerated/Main'

export default class CompanyCustomerAggregate {
    constructor(
        public readonly customer: Customer,
        public readonly companyCustomer: CompanyCustomer,
    ) {
        ensureNoUndefinedProperties(this)
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(
        entityData: CompanyCustomerAggregateData,
    ): CompanyCustomerAggregate {
        return new CompanyCustomerAggregate(
            Customer.hydrateSingle(entityData.customer),
            CompanyCustomer.hydrateSingle(entityData.companyCustomer),
        )
    }

    static hydrateMultiple(
        entitiesData: CompanyCustomerAggregateData[],
    ): CompanyCustomerAggregate[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
